import { render } from "./InviteUsersModal.vue?vue&type=template&id=c3f1c19e"
import script from "./InviteUsersModal.vue?vue&type=script&lang=js"
export * from "./InviteUsersModal.vue?vue&type=script&lang=js"
script.render = render

export default script